import { FC } from 'react';
import { FileCard, FileItem } from '../FileCard/FileCard';

interface FileSectionProps {
  title: string;
  files: FileItem[];
  onDownload: (url: string, name: string) => void;
  onRetry?: (id: number) => void;
  clickable?: boolean;
  showStatus?: boolean;
}

export const FileSection: FC<FileSectionProps> = ({
  title,
  files,
  onDownload,
  onRetry,
  clickable,
  showStatus,
}) => {
  if (files.length === 0) return null;

  return (
    <div className="flex flex-col gap-2">
      {title && (
        <h4 className="[font-size:var(--fs-p4)]! text-(--neutral-black-NB1000)! font-semibold m-0!">
          {title}
        </h4>
      )}
      <div className="flex flex-col gap-2">
        {files.map((file) => (
          <FileCard
            key={file.id}
            file={file}
            onDownload={onDownload}
            onRetry={onRetry}
            clickable={clickable}
            showStatus={showStatus}
          />
        ))}
      </div>
    </div>
  );
};
